import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { IconContext } from 'react-icons';
import { FaYoutube } from "react-icons/fa";

const HorizontalTimeline: React.FC = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size on mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const timelineEvents = [
    {
      time: t('MainMilestoneTime1'),
      description: t('MainMilestoneNote1'),
      icon: '/image/icon_1.png',
      position: 'bottom'
    },
    {
      time: t('MainMilestoneTime2'),
      description: t('MainMilestoneNote2'),
      icon: '/image/icon_2.png',
      position: 'top'
    },
    {
      time: t('MainMilestoneTime3'),
      description: t('MainMilestoneNote3'),
      icon: '/image/icon_3.png',
      position: 'bottom'
    },
    {
      time: t('MainMilestoneTime4'),
      description: t('MainMilestoneNote4'),
      icon: '/image/icon_4.png',
      position: 'top'
    }
  ];

  return (
    <div className={`w-full px-4 ${isMobile ? 'py-8' : 'py-36'}`}>
      {/* Mobile View - Vertical Timeline */}
      <div className={`${isMobile ? 'block' : 'hidden'} relative max-w-sm mx-auto`}>
        {/* Vertical Line */}
        <div className="absolute left-2 top-2 bottom-24 w-1 bg-gray-300"></div>

        {/* Timeline Points */}
        <div className="relative space-y-12">
          {timelineEvents.map((event, index) => (
            <div
              key={index}
              className="relative flex items-start"
            >
              {/* Circle */}
              <div className="w-6 h-6 mt-2 rounded-full bg-white border-4 border-white shadow-md mr-5"></div>

              {/* Time and Description */}
              <div className="flex-1">
                <div className="flex items-center mb-2">
                  <img
                    src={event.icon}
                    alt={event.description}
                    className="w-10 h-10 object-contain mr-3"
                  />
                  <div className="font-bold text-[#EEDCA0]">
                    {event.time}
                  </div>
                </div>
                <div className="text-sm">{event.description}</div>

                {event.time === t('MainMilestoneTime4') && (
                  <div className="mt-3">
                    <div className="flex items-center space-x-2 mb-2">
                      <IconContext.Provider value={{ color: "red", size: '20', className: "inline-block" }}>
                        <FaYoutube />
                      </IconContext.Provider>
                      <a
                        href="https://youtu.be/qee1KspdDRo"
                        target="_blank"
                        rel="noreferrer"
                        className="transition-colors duration-300 font-semibold text-xs underline"
                      >
                        GBA Taxi 輪住暢遊慈善活動
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop View - Horizontal Timeline */}
      <div className={`${isMobile ? 'hidden' : 'block py-20'} relative w-full max-w-4xl mx-auto`}>
        {/* Horizontal Line */}
        <div className="absolute top-1/2 transform -translate-y-1/2 w-full h-1 bg-gray-300"></div>

        {/* Timeline Points */}
        <div className="relative flex justify-between items-center">
          {timelineEvents.map((event, index) => (
            <div
              key={index}
              className="relative z-10 flex flex-col items-center"
            >
              {/* Circle */}
              <div className="w-6 h-6 rounded-full bg-white border-4 border-white shadow-md"></div>

              {/* Time and Description */}
              <div className={`absolute w-40 md:w-52 text-center ${
                event.position === 'top'
                  ? '-top-32 md:-top-48'
                  : 'top-12'
              }`}>
                <div className="flex justify-center mb-2">
                  <img
                    src={event.icon}
                    alt={event.description}
                    className="w-10 h-10 md:w-12 md:h-12 object-contain"
                  />
                </div>
                <div className="font-bold text-[#EEDCA0]">
                  {event.time}
                </div>
                <div className="text-xs md:text-sm mt-1">{event.description}</div>
                {event.time === t('MainMilestoneTime4') && (
                  <div className="mt-3">
                    <div className="flex items-center justify-center space-x-2 mb-2">
                      <IconContext.Provider value={{ color: "red", size: '20', className: "inline-block" }}>
                        <FaYoutube />
                      </IconContext.Provider>
                      <a
                        href="https://youtu.be/qee1KspdDRo"
                        target="_blank"
                        rel="noreferrer"
                        className="transition-colors duration-300 font-semibold text-xs md:text-sm underline"
                      >
                        GBA Taxi 輪住暢遊慈善活動
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HorizontalTimeline;